import { render, staticRenderFns } from "./OfferedResourcesCard.html?vue&type=template&id=30b7133a&"
import script from "./OfferedResourcesCard.js?vue&type=script&lang=js&"
export * from "./OfferedResourcesCard.js?vue&type=script&lang=js&"
import style0 from "./OfferedResourcesCard.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports